import * as React from 'react';
import { RowList, ScrollView, Sheet, TextRow } from 'smoothie';

interface AvailableBalanceInfoSheetProps {
    isOpen: boolean;
    onClose: () => void;
    totalCurrentBalance: string;
    totalAvailableBalance: string;
    totalCardBalance?: string;
    totalPendingTransfers?: string;
    totalPendingCardTransactions?: string;
    allAccountsOverview?: boolean;
    hasCards: boolean;
}

const AvailableBalanceInfoSheet = ({
    isOpen,
    onClose,
    totalCurrentBalance,
    totalAvailableBalance,
    totalCardBalance,
    totalPendingTransfers,
    totalPendingCardTransactions,
    allAccountsOverview,
    hasCards,
}: AvailableBalanceInfoSheetProps) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Available balance"
            showCloseButton
        >
            <ScrollView showsVerticalScrollIndicator={false}>
                <RowList>
                    <TextRow
                        title={`Cash Account balance${allAccountsOverview ? 's' : ''}`}
                        subtitle={`The total balance of your Cash Account${allAccountsOverview ? 's' : ''} and the amount you earn interest on.`}
                        secondaryText={totalCurrentBalance ?? '$0.00'}
                    />
                    <TextRow
                        title="Pending transfers"
                        subtitle={`Transfers into ${allAccountsOverview ? 'all accounts' : 'this account'} that haven't posted.`}
                        secondaryText={totalPendingTransfers ?? '$0.00'}
                    />
                    {hasCards && (
                        <>
                            <TextRow
                                title="Pending card transactions"
                                subtitle="Card transactions that haven't posted."
                                secondaryText={
                                    totalPendingCardTransactions ?? '$0.00'
                                }
                            />
                            <TextRow
                                title="Card balance"
                                subtitle="Card transactions that haven't been paid off."
                                secondaryText={totalCardBalance ?? '$0.00'}
                            />
                        </>
                    )}
                    <TextRow
                        title="Available balance"
                        subtitle={
                            hasCards
                                ? 'Cash Account balance minus pending transfers, pending card transactions, and outstanding card balances.'
                                : 'Cash Account balance minus pending transfers.'
                        }
                        secondaryText={totalAvailableBalance ?? '$0.00'}
                    />
                </RowList>
            </ScrollView>
        </Sheet>
    );
};

export default AvailableBalanceInfoSheet;
